import { CometChat } from "@cometchat/chat-sdk-javascript";
import { Selection } from "./useChatData";

/** True if `msg` belongs to the conversation `selection` currently has
 * open — shared by useNotifications (skip alerting for it) and
 * useActivityLogger (skip counting it as unseen), so a message you're
 * already looking at live doesn't also show up as "you missed this." */
export function messageBelongsToSelection(msg: CometChat.BaseMessage, selection: Selection | null): boolean {
  if (!selection) return false;
  if (msg.getReceiverType() === "group") {
    return selection.kind === "group" && selection.id === msg.getReceiverId();
  }
  const senderUid = msg.getSender()?.getUid();
  return selection.kind === "user" && (selection.id === senderUid || selection.id === msg.getReceiverId());
}
